<div class="form-field">
  @if (configJson().inputs[0] && dnpe()) {
    <div class="dnpe-lookup-form-wrapper">
      <div class="dnpe-field-group">
        <div class="center-labels number-label">
          <label for="dnpe-lookup-input" id="dnpe-lookup-label">{{ configJson().inputs[0].label }}</label>
          <small id="dnpe-lookup-required">*</small>
          <span [class.margin-align]="configJson().inputs[0].instructions">{{ configJson().inputs[0].instructions }}</span>
        </div>
        <mat-form-field appearance="outline" class="enrollment-builder-input form-field-input field-size">
          <input aria-labelledby="dnpe-lookup-label"
                 autocomplete="off"
                 [formControl]="dnpe()"
                 id="dnpe-lookup-input"
                 matInput
                 pattern="^\d+$"
                 [attr.data-qa]="'dnpe-lookup-' + configJson().inputs[0].id"
                 [max]="configJson().inputs[0].max"
                 [min]="configJson().inputs[0].min"
                 [placeholder]="configJson().inputs[0].placeholder ?? ''"
                 [readonly]="enrollmentBuilderView()"/>
        </mat-form-field>

        @if (dnpe().touched) {
          @if (dnpe().errors?.[Validation.Required]) {
            <mat-error>A DNPE number is required</mat-error>
          }

          @if (dnpe().errors?.[Validation.MaxLength] || dnpe().errors?.[Validation.Pattern]) {
            <mat-error>Invalid DNPE Number</mat-error>
          }

          @if (dnpe().errors?.['NotFound']) {
            <mat-error>In order to register as a direct payment school with the K12 Programs, your school must first be registered as a nonpublic school with the Division of Nonpublic Education (DNPE). Contact DNPE directly to register your school prior to registering with SEAA.</mat-error>
          }

          @if (dnpe().errors?.['Registered']) {
            <mat-error>Your school is already registered with SEAA. Contact your HDMA for assistance accessing your school’s record.</mat-error>
          }

          @if (dnpe().errors?.['Closed']) {
            <mat-error>Your school is listed as closed with the Division of Nonpublic Education (DNPE). Contact DNPE directly to reopen your school before registering with SEAA.</mat-error>
          }
        }
      </div>
    </div>
  }
</div>
